import React, { useContext } from 'react';
import { CELL_STYLE } from '~/web-frontend-core/api/const/base';
import { HightlightCoefTd, Td } from '~/web-frontend-components/line/outcomes.mobile/additional/tables/Td.mobile';
import { LineContext } from '~/web-frontend-components/context/AppContexts';
import { insertCoefByType } from "~/web-frontend-core/helpers/calcCoefType/insertCoefByType";
export const Row = React.memo((props) => {
    const row = props.tr.reduce((row, cell, i) => {
        row[Math.floor(i / 2)] = Object.assign(Object.assign({}, row[Math.floor(i / 2)]), cell);
        return row;
    }, []).filter(({ st }) => st === CELL_STYLE.COEFFICIENT);
    const { coefType, appName } = useContext(LineContext);
    return <div className='live__item__game-bets'>
      {row.filter((cell) => !!cell.bet)
            .map((cell, i, row) => cell.bet && props.getCoef(cell.bet) ?
            <HightlightCoefTd disabled={!!props.disabled} key={`${cell.bet || cell.txt}_${i}`} highlightChanges={props.highlightChanges} isCoefChoosen={props.isCoefChoosen} style={props.getColumnStyle ? props.getColumnStyle(i, row) : {}} coef={props.getCoef(cell.bet)} typeCoef={insertCoefByType(Number(props.getCoef(cell.bet).cf), coefType, appName)} onClick={props.onCoefChoose} cell={cell} matchID={props.matchID}/> :
            <Td cell={cell} cf={''} key={`${cell.txt}_${i}`}/>)}
   </div>;
});
export const TBody = React.memo((props) => <div className='g-t-b'>
      {props.rows.map((tr, i) => <Row tr={tr} {...props} key={i}/>)}
   </div>);
export const SubHeader = React.memo((props) => {
    const headers = props.row.filter(isSubheaderCell);
    if (headers.length === 0) {
        return null;
    }
    return <div className='g-t-h-sm'>
      {headers.map((cell) => <div className='g-t-pl' title={cell.txt} key={cell.txt}>{cell.txt}</div>)}
   </div>;
});
const isSubheaderCell = ({ st }) => st === CELL_STYLE.SUBHEADER || st === CELL_STYLE.HEADER;
export const isSubheaderRow = (row) => row.some(isSubheaderCell);



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes.mobile/additional/tables/TBody.mobile.jsx